import { render, staticRenderFns } from "./PhotoPostMedia.vue?vue&type=template&id=6346882a&scoped=true&"
import script from "./PhotoPostMedia.vue?vue&type=script&lang=js&"
export * from "./PhotoPostMedia.vue?vue&type=script&lang=js&"
import style0 from "./PhotoPostMedia.vue?vue&type=style&index=0&id=6346882a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6346882a",
  null
  
)

export default component.exports